export function getConfig(mode) {
    // Create initial config with prod settings
    const config = {
        storeId: 'f8920f29-51d9-4c84-930c-ac56c472106b',
        environment: 'production',
    }

    // if staging then override with staging settings
    if (mode === 'staging') {
        config.storeId = '9f7ededd-628e-47bf-b028-a83925bc4977'
        config.environment = 'demo'
    }

    return config
}
